import { Type } from 'typebox';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
import { ShortIsoCalendarDateCodec } from '../../utils/register-typebox-short-iso-calendar-date-format.js';
export const ScheduleEnrollments = {
    day: 'Day',
    morning: 'Morning',
    afternoon: 'Afternoon',
    beforeAfterSchool: 'Before/After School',
    unknown: 'unknown'
};
export const ScheduleEnrollment = Type.Union([
    Type.Literal(ScheduleEnrollments.day),
    Type.Literal(ScheduleEnrollments.morning),
    Type.Literal(ScheduleEnrollments.afternoon),
    Type.Literal(ScheduleEnrollments.beforeAfterSchool),
    Type.Literal(ScheduleEnrollments.unknown)
]);
export const ScheduleEnrollmentCodec = createFallbackStringEnumCodec(ScheduleEnrollments, ScheduleEnrollments.unknown);
export const ScheduleDay = Type.Object({
    scheduled: Type.Boolean()
});
export const Schedule = Type.Object({
    key: Type.String({ minLength: 1 }),
    monday: ScheduleDay,
    tuesday: ScheduleDay,
    wednesday: ScheduleDay,
    thursday: ScheduleDay,
    friday: ScheduleDay,
    saturday: ScheduleDay,
    sunday: ScheduleDay,
    enrollment: Type.Optional(ScheduleEnrollmentCodec),
    returnDate: Type.Optional(ShortIsoCalendarDateCodec),
    enrollmentDate: Type.Optional(ShortIsoCalendarDateCodec),
    graduationDate: Type.Optional(ShortIsoCalendarDateCodec)
});
